import { HONEYPOT_FIELD_NAME } from "@homeinstead/forms/lead-form";

/**
 * Honeypot rejections come back as a field-level error on the honeypot input
 * so the response is shaped like any other validation failure. The field name
 * is reserved (RESERVED_LEAD_FORM_FIELD_NAMES), so no authored step can
 * produce it — its presence only ever means the trap was filled.
 */
function isHoneypotRejection(
  validationErrors: Record<string, string> | undefined,
): boolean {
  return validationErrors != null && HONEYPOT_FIELD_NAME in validationErrors;
}

export { isHoneypotRejection };
